import { ContactType } from 'types/Invitation';
import { ProcessEmailRecipient } from 'types/Process';

const CONTACT_TYPE_TO_PROP: Record<ContactType, keyof ProfileContact> = {
  [ContactType.PRIMARY_CONTACT]: 'contactoPrincipal',
  [ContactType.SECONDARY_CONTACT]: 'contactoSecundario',
  [ContactType.INTERMEDIARY]: 'intermediario',
  [ContactType.LEGAL_REPRESENTATIVE]: 'representanteLegal',
  [ContactType.LAWYER]: 'abogado',
};

export type ProfileContact = {
  email: string,
  cuentaDeInversionId: number,
  contactoPrincipal?: boolean,
  contactoSecundario?: boolean,
  representanteLegal?: boolean,
  intermediario?: boolean,
  abogado?: boolean,
};

export function buildEmailsFromContacts(
  contacts: ProfileContact[],
  contactTypes: ContactType[],
): ProcessEmailRecipient[] {
  return contacts
    .filter( ( contact ) => (
      contact?.email
        && contact.cuentaDeInversionId != null
        && contactTypes.some( ( type ) => {
          const prop = CONTACT_TYPE_TO_PROP[type];
          return prop && contact[prop] === true;
        } )
    ) )
    .map( ( contact ) => ( {
      email: contact.email,
      accountId: contact.cuentaDeInversionId,
    } ) );
}
